<template>
    <div>
        <div class="row">
            <h1 class="page-title page-title--single">
                <span>Invoices</span> Referral partner
            </h1>
        </div>

        <div
            class="row referral-invoices-filter filter referral-partners--filter"
        >
            <form method="get">
                <div class="group-filter group-filter--left">
                    <div class="form-field form-field__select">
                        <label for="agency">Referral partner</label>
                        <v-select
                            label="name"
                            :options="filter_partners"
                            @input="changePartnerSelect"
                        >
                        </v-select>
                    </div>
                    <div class="select">
                        <div
                            class="form-field form-field__select form-field--inline-flex"
                        >
                            <label for="period">Sale Period</label>
                            <select
                                name="period"
                                id="period"
                                @change="setValue"
                                class="js-select-custom"
                            >
                                <option value="">All</option>
                                <option
                                    v-for="period in periods"
                                    :key="period"
                                    :value="period"
                                    v-text="formatDatePeriod(period)"
                                />
                            </select>
                        </div>
                    </div>
                </div>

                <div class="group-filter group-filter--status">
                    <div class="checkbox">
                        <!-- ALL CHECKBOX -->
                        <div class="form-field checkbox-wrap">
                            <input
                                type="checkbox"
                                id="filter_status_all"
                                value="all"
                                checked
                                :ref="'filter_status_all'"
                                @change="handleCheckAllStatus"
                            />
                            <label for="filter_status_all"
                                ><i class="icon icon-checkmark"></i
                            ></label>
                            All
                        </div>
                        <!-- end ALL CHECKBOX -->
                        <div
                            class="form-field checkbox-wrap"
                            v-for="filter in statuses"
                            :key="filter.id"
                        >
                            <input
                                type="checkbox"
                                :id="`filter_status_${filter.id}`"
                                :value="filter.id"
                                :ref="`filter_status_${filter.id}`"
                                @change="checkboxValue"
                                name="status[]"
                            />
                            <label :for="`filter_status_${filter.id}`"
                                ><i class="icon icon-checkmark"></i
                            ></label>
                            {{ filter.name }}
                        </div>
                    </div>
                </div>
            </form>
            <div class="form-field form-field--button form-field--button-new">
                <button
                    @click="openColumnsModal"
                    type="button"
                    class="btn btn--gray"
                >
                    Edit column view
                </button>
            </div>
        </div>

        <div
            class="row master-invoices-pagination master-invoices-pagination--top"
        ></div>

        <div class="row agencies-table">
            <div class="table-wrap">
                <table class="table">
                    <thead>
                        <tr
                            v-if="current_columns && current_columns.length > 0"
                        >
                            <th
                                v-for="col_obj in current_columns
                                    .filter((c) => c.status === 'show')
                                    .sort((a, b) => a.position - b.position)"
                                v-bind:key="'col_table_th_' + col_obj.id"
                                @click="sortData(col_obj.slug)"
                            >
                                <span
                                    v-if="lastSort == col_obj.slug"
                                    :class="
                                        descending &&
                                        lastSort == col_obj.slug &&
                                        'sort-icon--desc'
                                    "
                                    ><i class="icon icon-down-arrow"></i
                                ></span>
                                {{ col_obj.name }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loading">
                            <td colspan="16">
                                <clip-loader
                                    :loading="loading"
                                    :color="'#ec4657'"
                                    :size="'45px'"
                                ></clip-loader>
                            </td>
                        </tr>
                        <tr v-else-if="!items.length && !loading">
                            <td colspan="16"><center>No data</center></td>
                        </tr>
                        <tr
                            v-else-if="selectedPartner && filterItems.length"
                            v-for="item in filterItems"
                        >
                            <td
                                v-for="_col in current_columns.filter(
                                    (c) => c.status === 'show'
                                )"
                                v-bind:key="'col_table_partner_' + _col.id"
                            >
                                <a
                                    v-if="_col.is_link && item[_col.slug].link"
                                    :href="item[_col.slug].link"
                                    :style="
                                        item.status == 'Overdue'
                                            ? 'color:red'
                                            : ''
                                    "
                                    >{{ item[_col.slug].name }}</a
                                >
                                <p
                                    v-else
                                    :class="
                                        !item[_col.slug] ||
                                        item[_col.slug] === '-' ||
                                        item[_col.slug] <= 0
                                            ? 'color-of-null'
                                            : ''
                                    "
                                >
                                    {{ item[_col.slug] || "-" }}
                                </p>
                            </td>
                        </tr>
                        <tr v-else v-for="item in items">
                            <td
                                v-for="_col in current_columns.filter(
                                    (c) => c.status === 'show'
                                )"
                                v-bind:key="'col_table_partner_' + _col.id"
                            >
                                <a
                                    v-if="_col.is_link && item[_col.slug].link"
                                    :href="item[_col.slug].link"
                                    :style="
                                        item.status == 'Overdue'
                                            ? 'color:red'
                                            : ''
                                    "
                                    >{{ item[_col.slug].name }}</a
                                >
                                <p
                                    v-else
                                    :class="
                                        !item[_col.slug] ||
                                        item[_col.slug] === '-' ||
                                        item[_col.slug] <= 0
                                            ? 'color-of-null'
                                            : ''
                                    "
                                >
                                    {{ item[_col.slug] || "-" }}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row master-invoices-pagination jus-c--right"></div>

        <Column_Modal
            :is_show="showModalColumns"
            :__columns="current_columns"
            :selectColumn="selectColumn"
            :closeModal="closeModal"
            :selected_col="selected_col"
            v-if="showModalColumns"
        ></Column_Modal>
    </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import axios from "axios";
import * as sortArray from "../../parts/sort-array";
import Column_Modal from "../ColumnModal";

export default {
    name: "PartnerInvoices",
    props: ["agencies", "statuses", "brands", "periods", "columns"],
    components: {
        ClipLoader,
        Column_Modal,
    },
    data() {
        return {
            selectedStatus: [],
            agency: null,
            period: null,
            loading: false,
            filterItems: [],
            selectedPartner: { id: 0, name: "All" },
            items: [],
            descending: false,
            lastSort: "id",
            showModalColumns: false,
            selected_col: null,
            current_columns: [],
            filter_columns: [],
        };
    },

    mounted() {
        this.current_columns = JSON.parse(JSON.stringify(this.columns));

        this.fetchData();
    },

    computed: {
        filter_partners() {
            const filterPartnersArr = this.items.map((item) => {
                return {
                    id: item.partner.id,
                    name: item.partner.name,
                };
            });

            const uniqueFilters = [
                ...new Map(
                    filterPartnersArr.map((item) => [item["id"], item])
                ).values(),
            ];

            return uniqueFilters;
        },
    },

    methods: {
        formatDatePeriod(date) {
            const options = { year: "numeric", month: "long" };
            const _date = new Date(date);

            return _date.toLocaleDateString("en-GB", options);
        },
        changeSelect(e) {
            const id = e.id;

            if (id) {
                this.selectedPartner = id;
                this.filterData(id);
            } else {
                this.selectedPartner = null;
                this.filterItems = [];
            }
        },
        changePartnerSelect(e) {
            const id = e.id;

            if (id) {
                this.selectedPartner = id;
                this.filterPartnerData(id);
            } else {
                this.selectedPartner = null;
                this.filterItems = [];
            }
        },
        setValue(e) {
            const name = e.target.name;
            const value = e.target.value;

            this[name] = value;

            this.fetchData();
        },
        checkboxValue(e) {
            if (e.target.checked) {
                this.selectedStatus.push(e.target.value);
                if (this.$refs.filter_status_all.checked) {
                    this.$refs.filter_status_all.click();
                }
            } else {
                this.selectedStatus = this.selectedStatus.filter(
                    (i) => i != e.target.value
                );
            }

            this.fetchData();
        },

        fetchData() {
            this.loading = true;

            axios
                .post("/partner-invoices/getList", {
                    status: this.selectedStatus,
                    brand: this.brand,
                    agency: this.agency,
                    period: this.period,
                })
                .then((res) => {
                    this.loading = false;
                    if (res.data.length) {
                        this.items = this.reformatDataByColumns(res.data);
                    } else {
                        this.items = [];
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        filterData(id = null) {
            this.filterItems = this.items.filter((item) => item.id === id);
        },
        filterPartnerData(id = null) {
            this.filterItems = this.items.filter(
                (item) => item.partner.id === id
            );
        },
        sortData(sortBy) {
            let self = this;
            if (self.lastSort !== sortBy) self.descending = false;
            self.lastSort = sortBy;
            switch (sortBy) {
                case "id":
                    self.items = self.items.sort(
                        sortArray.sortNumber("id", self.descending, "name")
                    );
                    break;
                case "name":
                    self.items = self.items.sort(
                        sortArray.sortText(
                            "partner",
                            self.descending,
                            (a) => a.toUpperCase(),
                            "name"
                        )
                    );
                    break;
                case "partner":
                    self.items = self.items.sort(
                        sortArray.sortText(
                            "partner",
                            self.descending,
                            (a) => a.toUpperCase(),
                            "name"
                        )
                    );
                    break;
                case "status":
                    self.items = self.items.sort(
                        sortArray.sortText("status", self.descending, (a) =>
                            a.toUpperCase()
                        )
                    );
                    break;
                case "period":
                    self.items = self.items.sort(
                        sortArray.sortDate("period", self.descending)
                    );
                    break;
                case "commission_payable":
                    self.items = self.items.sort(
                        sortArray.sortNumber(
                            "commission_payable",
                            self.descending
                        )
                    );
                    break;
                case "due_date":
                    self.items = self.items.sort(
                        sortArray.sortDate("due_date", self.descending)
                    );
                    break;
                case "paid":
                    self.items = self.items.sort(
                        sortArray.sortDate("paid", self.descending)
                    );
                    break;
            }
            self.descending = !self.descending;
        },
        // MODAL COLUMNS
        reformatDataByColumns(__items = []) {
            try {
                if (__items.length >= 1) {
                    const newFormatData = [];
                    if (this.current_columns.length >= 1) {
                        __items.forEach((item) => {
                            const tempObj = {};
                            this.current_columns
                                .sort((a, b) => a.position - b.position)
                                .forEach((c) => {
                                    if (c.status === "hidden") {
                                        return;
                                    }
                                    tempObj[`${c.slug}`] = item[c.slug];

                                    if (c.slug === "id") {
                                        tempObj["id"] = {
                                            name: item["id"],
                                            link: item["url"],
                                        };
                                    }

                                    if (c.slug === "partner") {
                                        tempObj["partner"] = {
                                            id: item["partner"].id,
                                            name: item["partner"].name,
                                            link: item["partner"].url,
                                        };
                                    }
                                });

                            newFormatData.push(tempObj);
                        });
                        return newFormatData;
                    }
                }

                return [];
            } catch (err) {
                console.error("reformatDataByColumns error", err);
            }
        },
        openColumnsModal() {
            this.showModalColumns = true;
            document.querySelector("html").style = "overflow-y: hidden";
            document.querySelector("body").style =
                "overflow-y: hidden; margin-right: 16px";
        },
        async closeModal(items = []) {
            await axios
                .post("/master-invoices/updateColumns", {
                    columns: items,
                })
                .then(() => {
                    this.showModalColumns = false;
                    this.current_columns.length = 0;
                    this.current_columns = JSON.parse(JSON.stringify(items));
                    document.querySelector("html").style = "";
                    document.querySelector("body").style = "";
                })
                .catch((err) => {
                    console.error("Axios update columns error", err);
                });
        },
        selectColumn(col) {
            this.selected_col = col;
        },
        handleCheckAllStatus(e) {
            if (e.target.checked) {
                this.selectedStatus = [];
                this.statuses.forEach((filter) => {
                    const _checkbox =
                        this.$refs[`filter_status_${filter.id}`][0];
                    if (_checkbox.checked) {
                        _checkbox.click();
                    }
                });
            }
        },
    },
};
</script>
